<template>
  <b-card
    :img-src="'img/membership/' + membership.imageId"
    img-alt="Image"
    img-top
    tag="article"
    class="d-flex w-100 h-100 shadow-sm border"
  >
    <table
      cellpadding="0"
      cellspacing="0"
      border="0"
      width="100%"
      height="100%"
    >
      <tr>
        <td align="left" valign="top">
          <h2>{{ membership.label }}</h2>
          <p class="text-muted">{{ membership.description }}</p>
        </td>
      </tr>
      <tr>
        <td align="left" valign="top" class="pt-3">
          <b-row>
            <b-col cols="4">
              <h3 class="mb-0">
                {{ (membership.monthlyAmount / 100) | currency }}
              </h3>
              <span class="text-muted">Monthly</span>
            </b-col>
            <b-col cols="8">
              <h3 class="mb-0">
                {{ (membership.yearlyAmount / 100) | currency }}
              </h3>
              <span class="text-muted">Yearly</span>
            </b-col>
          </b-row>
        </td>
      </tr>
      <tr>
        <td height="100%" align="left" valign="top" class="pt-4 pb-4">
          <ul
            style="list-style-type: none;"
            class="p-0 m-0 border-top"
            v-for="point in membership.membershipBenefits"
            :key="point.id"
          >
            <li class="pt-2 pb-2">{{ point.label }}</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td align="left" valign="top">
          <b-button
            href="#"
            class="btn-block"
            @click="$emit('editMembership', membership)"
            variant="primary"
            >Edit Membership</b-button
          >
        </td>
      </tr>
    </table>
  </b-card>
</template>

<script>
export default {
  name: "membership-item",
  props: { membership: null },
  methods: {
    getSavings(listPrice, actualPrice) {
      var per = ((listPrice - actualPrice) / listPrice) * 100;

      if (per >= 0) return per.toFixed(0) + "% Savings";
      else return per.toFixed(0) + "% Not Being Saved";
    },
  },
};
</script>

<style>


.yummy {
  display: table;
  height: 100%;
}

.yum {
  display: table-cell;
  width: 100%;
}
</style>
